import React from 'react';
import './LeaderBoardTopInt.css';
import { resolveTutorDetailsLeaderboardAsset, globalText } from '../tutorDetailsLeaderboardConfig';
export default function LeaderBoardTopInt({ data, info, inPage = false, config = {} }) {
	const images = config.images || {};
	const pointsLabel = globalText.points_label || 'Points';
	const winnerCap = resolveTutorDetailsLeaderboardAsset(images.first_rank_cap || 'https://cdn-cp-assets-public.classplus.co/campaigns-assets/15-aug-26-default-img.jpg');
	const organizationLogoFallback = resolveTutorDetailsLeaderboardAsset(images.organization_logo_fallback || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-default-img.jpeg');
	return (
		<div className="leaderBoardBox">
			<div className="leaderboardPoints">
				<div className="leaderboardColumn columnSecond" style={{borderBottomRightRadius: '0px'}}>
					<div className="leaderboardColumnImg" >
						<img src={data?.[1]?.orgLogo ? data?.[1]?.orgLogo : organizationLogoFallback} alt="person" width={50} height={50}/>
						<span className="pointNumber">2</span>
					</div>
					<h4>{data?.[1]?.orgName}</h4>
					<h2>{data?.[1]?.points}</h2>
					<p>{pointsLabel}</p>
				</div>
				<div className="leaderboardColumn columnFirst">
					<div className="leaderboardColumnImg">
						<img className="imgWinner" src={winnerCap} alt="cap" height={27} width={57}/>
						<img src={data?.[0]?.orgLogo ? data?.[0]?.orgLogo : organizationLogoFallback} alt="person" width={75} height={75}/>
						<span className="pointNumber">1</span>
					</div>
					<h4>{data?.[0]?.orgName}</h4>
					<h2>{data?.[0]?.points}</h2>
					<p>{pointsLabel}</p>
				</div>
				<div className="leaderboardColumn columnThird" style={{borderBottomLeftRadius: '0px'}}>
					<div className="leaderboardColumnImg" >
						<img src={data?.[2]?.orgLogo ? data?.[2]?.orgLogo : organizationLogoFallback} alt="person" width={50} height={50}/>
						<span className="pointNumber">3</span>
					</div>
					<h4>{data?.[2]?.orgName}</h4>
					<h2>{data?.[2]?.points}</h2>
					<p>{pointsLabel}</p>
				</div>
			</div>
		</div>
	);
}
